<template>
    <div>
        <slot v-bind="this" />
    </div>
</template>

<script>
    export default {
        props: {
            data: {
                type: Object,
                default:() => ({
                    type: null,
                })
            },
        },
        data() {
            return {
                type: this.data.type,
            }
        },
        methods: {
            handleTypeChanged(type) {
                this.type = type;
            },
        },
    }
</script>